export const Bio = {
  name: "Shreyas Hingmire",
  roles: [
    "Data Scientist",
    "Data Analyst",
    "Business Analyst",
    
  ],
  description:
  "Data Scientist with 3+ YoE, specializing in machine learning, big data analytics, and AI-driven solutions across finance, retail, and customer analytics. Skilled in developing scalable models and leveraging predictive analytics to optimize decision-making and drive business impact. Actively seeking a full-time position in a Data Science-focused role.",
  github: "https://github.com/shreyasah99",
  resume:
    "https://drive.google.com/file/d/1vGF0QVHi1R9EHqqDh7ZnDyk62WO7SXaC/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/shreyas-hingmire/",
  insta: "https://www.instagram.com/shreyas__hingmire/",
};

export const skills = [
  {
    title: "Programming & Databases",
    skills: [
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "R",
        image: "https://www.r-project.org/logo/Rlogo.png",
      },
      {
        name: "SAS",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/sas.PNG",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Expertise",
    skills: [
      {
        name: "Machine Learning",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/ML.PNG",
      },
      {
        name: "Data Modeling",
        image: "https://www.mongodb.com/assets/images/global/favicon.ico",
      },
      {
        name: "Data Preprocessing",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/preprocessing.PNG",
      },
      {
        name: "EDA",
        image: "https://upload.wikimedia.org/wikipedia/commons/8/84/Matplotlib_icon.svg",
      },
      {
        name: "Statistical Analysis",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Stats.PNG",
      },
      {
        name: "Agentic LLMs",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/LLM.PNG",
      },
    ],
  },
  {
    title: "Visualization & Big Data",
    skills: [
      {
        name: "Tableau",
        image: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Tableau_Logo.png",
      },
      {
        name: "Power BI",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg",
      },
      {
        name: "Excel",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/excel.PNG",
      },
      {
        name: "Spark",
        image: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Apache_Spark_logo.svg",
      },
      {
        name: "Hadoop",
        image: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Hadoop_logo.svg",
      },
      {
        name: "Snowflake",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/snowflake.PNG",
      },
      {
        name: "Hive",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/hive.PNG",
      },
      {
        name: "Airflow",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/airflow.PNG",
      },
    ],
  },
  {
    title: "Others (Cloud & DevOps)",
    skills: [
      {
        name: "AWS",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "Azure",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg",
      },
      {
        name: "GCP",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/GCP.PNG",
      },
      {
        name: "CI/CD Pipelines",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/CICD.PNG",
      },
      {
        name: "Jenkins",
        image: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Jenkins_logo.svg",
      },
      {
        name: "Unix",
        image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Unix.PNG",
      },
      {
        name: "Git",
        image: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Git-logo.svg",
      },
    ],
  },
];


export const experiences = [
  {
    id: 0,
    img: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Thunderbird.PNG",
    role: "Graduate Research Assistant (Data Analyst)",
    company: "Thunderbird School of Global Management",
    date: "August 2024 - April 2024",
    desc: "•  Collaborating with Mayo Clinic, I optimized website analytics using Python, SQL, and Redshift, applying causal inference to boost forecasting accuracy by 18%. I also partnered with business leaders to define 12 KPIs and build a SQL-powered Tableau dashboard, driving data-driven strategies for user engagement & sales. •   For the ASU website, I designed 7 A/B tests, refining the homepage and CTAs, cutting the bounce rate by 25%, and increasing session duration by 24%. Leveraging LLM-powered NLP, I addressed negative reviews, reducing customer support costs by 20%. Additionally, I optimized ML models with Hive and SQL, enhancing spending predictions and boosting revenue forecasts by $600K.",
    skills: [
      "SQL",
      "Experimentation",
      "Visualization",
      "Causal Inference",
      "LLM",
      "Marketing & Product Analytics",
      "Revenue & Forecast Modeling",
    ],
  },
  {
    id: 1,
    img: "https://www.americanexpress.com/content/dam/amex/us/merchant/supplies-uplift/product/images/img-WEBLOGO1-01.jpg",
    role: "Finance Data Science Intern",
    company: "American Express",
    date: "June 2024 - August 2024",
    desc: "•  Was part of the CCAR team, optimizing SQL queries to cut execution time by 40%, accelerating CCAR modeling. Conducted trend and segment analysis on 18TB of data, enhancing forecast accuracy and risk management. Refined the credit line-down regression model, applying conservative adjustments that reduced billed business forecasts by 1.93%. Automated data transformation with Python, cutting preparation time by 55%, eliminating manual errors, and improving model reliability. Leveraged predictive analytics to assess spending patterns, minimizing unplanned financial exposure by 15%.",
       skills: [
      "SQL Optimization",
      "Predictive Analytics & Forecast Modeling",
      "Regression Analysis",
      "Big Data Analysis",
      "Risk Analytics ",

    ],
  },
  {
    id: 2,
    img: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Accenture.PNG",
    role: "Data Science Analyst",
    company: "Accenture",
    date: "June 2021 - July 2023",
    desc: "•  Worked for AT&T client, improving data quality through cleansing and preprocessing, reducing errors by 10%. I developed a GMM clustering model, driving a 26% increase in customer purchases through segment-specific marketing. Leading a team of three, I built an ANN model to predict customer attrition, reducing churn by 15% and preventing $1.2M in revenue loss. I also developed an XGBoost model for CLTV prediction, increasing revenue by 10% and cutting marketing costs by 5%. Deploying models via Jenkins and CI/CD pipelines, I reduced deployment failures by 30%. Additionally, I streamlined ETL pipelines and optimized Snowflake integration, cutting data latency by 25% and improving market responsiveness by 20%.",
    skills: [
      "Machine Learning",
      "Predictive Modeling",
      "Customer Analytics",
      "Data Preprocessing",
      "MLOps ",
      "Team Leadership ",
      "ETL",
    ],
  },
    {
    id: 3,
    img: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/suven.PNG",
    role: "Machine Learning Intern",
    company: "Suven Technology",
    date: "June 2020 - July 2020",
    desc: "•  I developed time-series forecasting models (ARIMA, SARIMA, Prophet) to predict weekly sales trends, reducing stockouts by 20% and optimizing inventory management. Using hypothesis testing and chi-square analysis, I uncovered a strong link between competitive pricing and repeat purchases, boosting customer retention by 10%. Additionally, I analyzed historical sales data to identify seasonal demand spikes, implementing predictive inventory forecasting, which further reduced stockouts by 25%.",
    skills: [
      "Time-Series Forecasting ","Retail & E-commerce Analytics",
      "Inventory Optimization & Demand Forecasting",
      
 
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/ASU.PNG",
    school: "Arizona State University, Tempe, AZ, United States",
    date: "August 2023 - May 2025",
    grade: "4.0 / 4.0 GPA",
    desc: "",
    degree: "Master of Science - MS, Data Science and Analytics",
  },
  {
    id: 1,
    img: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/UniMumbai.PNG",
    school: "University of Mumbai, Mumbai, MH, India",
    date: "August 2017 - June 2021",
    grade: "3.5 / 4.0 GPA",
    desc: "",
    degree: "Bachelor of Engineering - BE, Information Technology",
  },
];

export const projects = [
  {
    id: 88,
    title: "VLM on Multimodal LLM : QA Using Agentic Framework",
    date: "December 2024",
    description:
     "AnAI-powered multimodal question-answering system integrating text, image, and table data using an agent-based LLM framework.",
    image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/VLM_on_multilodal.webp",
    tags: ["Multimodal AI", "LLMs", "LangChain", "Gemini Pro", "Agentic Framework"],
    category: "GenAI/LLMs",
    github: "https://github.com/shreyasah99/VLM-on-Multimodal-LLM-QA-Using-Agentic-Framework",
    webapp: "https://github.com/shreyasah99/VLM-on-Multimodal-LLM-QA-Using-Agentic-Framework"
  },
  {
    id: 88,
    title: "ResumeAI: AI-Powered Resume Analysis & Job Matching",
    date: "December 2024",
    description:
      "​An AI-driven application that assists job seekers in enhancing their resumes by analyzing job descriptions, providing detailed feedback, suggesting skill improvements, and calculating a match percentage to increase job acquisition success.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Resume%20Analysis.webp",
    tags: ["AI", "Resume Enhancement","Job Matching", "LangChain", "FAISS", "HuggingFace", "Streamlit", "Llama"],
    category: "GenAI/LLMs",
    github: "https://github.com/shreyasah99/ResumeAI",
    webapp: "https://resumeai-shreyas.streamlit.app/"
  },
  {
    id: 88,
    title: "Text to SQL: Conversational AI for Database Interaction",
    date: "December 2024",
    description:
      "A Streamlit-based AI app that converts natural language queries into SQL using Groq’s LLaMA3 model to retrieve data from database",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Text%20to%20sql.webp",
    tags: ["LLM", "Groq API", "LangChain", "Text-to-SQL", "Streamlit", "SQLite", "Conversational AI", "NLP"],
    category: "GenAI/LLMs",
    github: "https://github.com/shreyasah99/Text-to-SQL-Conversational-AI-for-Database-Interaction",
    webapp: "https://text-to-sql-conversational-ai-for-database-interaction-shreyas.streamlit.app/",
  },
  {
    id: 6,
    title: "PDF-search-and-Summerization-App",
    date: "September 2023",
    description:
      "This project leverages GPT Index, Llama Index, and Streamlit. Users inquire, and GPT models extract answers from PDFs, offering swift, contextually rich responses. With an intuitive interface, this application enhances information retrieval and comprehension, showcasing the power of advanced natural language processing and streamlined document interaction.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/PDf%20search.webp",
    tags: ["GPT Index", "Llama Index", "Streamlit", "Python"],
    category: "GenAI/LLMs",
    github: "https://github.com/shreyasah99/-pdf-search-summarization",
    webapp: "https://github.com/shreyasah99/-pdf-search-summarization",
  },
 {
    id: 88,
    title: "CLTV Prediction & Customer Segmentation for Personalized Insurance Offerings",
    date: "December 2024",
    description:
      "An ML-driven approach to predict Customer Lifetime Value (CLTV) and segment insurance customers for targeted policy personalization and optimized marketing.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/cltv%20and%20segmentation.webp",
    tags: ["Regression (Gradient Boosting)", "Python", "Clustering (KMeans)", "Insurance Analytics", "Customer Segmentation", "CLTV Prediction"],
    category: "ML",
    github: "https://github.com/shreyasah99/CLTV-Prediction-and-Customer-Segmentation",
    webapp: "https://drive.google.com/file/d/1Qow6zCwz5wxf1v-WHf2MTglnRzN-7Shj/view?usp=sharing",
  },
  {
    id: 88,
    title: "Heart Scope: Heart Attack Prediction & Causal Analysis",
    date: "December 2024",
    description:
      "An interpretable AI system that predicts heart attack risk and uncovers the causal impact of lifestyle choices using machine learning and DoWhy-based causal inference.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/heart%20disease.webp",
    tags:  ["Healthcare AI", "Causal Inference", "Heart Disease Prediction","EBM"]    ,
    category: "ML",
    github: "https://github.com/shreyasah99/Heart-Attack-Prediction-Causal-Analysis",
    webapp: "https://github.com/shreyasah99/Heart-Attack-Prediction-Causal-Analysis",
  },
  {
    id: 88,
    title: "Crude Oil Price Predictor MLOps",
    date: "December 2024",
    description:
      "An end-to-end MLOps pipeline for forecasting Crude Oil prices using macroeconomic indicators, powered by H2O AutoML, MLflow, and Evidently AI on Databricks.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/crude%20oil.webp",
    tags:  ["MLOps", "H2O AutoML", "MLflow", "Databricks", "Evidently AI", "Random Forest", "Commodity Price Prediction"]    ,
    category: "ML",
    github: "https://github.com/shreyasah99/Crude_Oil_Price_Predictor-MLOps",
    webapp: "https://github.com/shreyasah99/Crude_Oil_Price_Predictor-MLOps",
  },
  {
    id: 88,
    title: "H&M Personalized Fashion Recommendation System",
    date: "December 2024",
    description:
      "A hybrid recommendation engine that combines collaborative filtering, popularity-based ranking, and customer segmentation to predict personalized fashion purchases for H&M customers.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/HM.webp",
    tags:  ["Recommender Systems", "Ensemble Learning", "Retail Analytics", "Kaggle", "Fashion AI"]    ,
    category: "ML",
    github: "https://github.com/shreyasah99/H-M-Personalized-Fashion-Recommendation-System",
    webapp: "https://github.com/shreyasah99/H-M-Personalized-Fashion-Recommendation-System",
  },
  {
    id: 88,
    title: "Hypothesis-Driven Analysis of Credit Card Customer Data",
    date: "December 2024",
    description:
      "Hypothesis-driven statistical analysis of credit card customer data to uncover factors influencing credit limits and attrition risk.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/Hypothesis.png",
    tags:  ["Hypothesis Testing", "Statistical Analysis", "Credit Risk", "EDA", "Customer Behavior"]    ,
    category: "Analytics/ Statistics",
    github: "https://github.com/shreyasah99/Hypothesis-Driven-Analysis-on-Credit-Limits-and-Attrition",
    webapp: "https://drive.google.com/file/d/14tszp-jP2mDKHHiizO-PgV7gIlG2pX51/view?usp=sharing",
  },
  {
    id: 88,
    title: "ETL and Analysis of Motor Vehicle Collision",
    date: "December 2024",
    description:
      "An end-to-end data pipeline project using Alteryx and Talend for ETL, dimensional modeling, and visualization to analyzex NYC motor vehicle collisions to uncover key accident patterns and high-risk zones.",
    image: "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/motor.png",
    tags:  ["Data Engineering", "ETL", "Alteryx", "Talend", "Dimensional Modeling", "Analysis, Visualization"]    ,
    category: "Analytics/ Statistics",
    github: "https://github.com/shreyasah99/ETL-and-Analysis-of-Motor-Vehicle-Collision",
    webapp: "https://github.com/shreyasah99/ETL-and-Analysis-of-Motor-Vehicle-Collision",
  },
  {
    id: 88,
    title: "Dashboard : Shopping Trends and Customer Behavior",
    date: "December 2024",
    description:
      "Interactive Tableau dashboard visualizing customer shopping trends, product preferences, and revenue insights to support data-driven business decisions.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/ift533.png",
    tags:  ["Tableau", "Data Visualization", "Dashboard Design", "Business Intelligence", "Retail Analytics", "Customer Behavior"]    ,
    category: "Analytics/ Statistics",
    github: "https://github.com/shreyasah99/Dashboard-Shopping-Trends-and-Customer-Behavior",
    webapp: "https://public.tableau.com/app/profile/shreyas.anil.hingmire/viz/ShoppingTrendsandCustomerBehavior/FinalStory",
  },
  {
    id: 88,
    title: "Real-Time Insurance Claims Data ETL Pipeline",
    date: "December 2024",
    description:
      "A real-time ETL pipeline for insurance claims data built with Python, AWS, Snowflake, and Airflow, enabling automated processing and visualization of structured claim insights in Tableau.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/insuarance.png",
    tags:  ["ETL Pipeline", "Apache Airflow", "AWS S3", "Snowflake", "Insurance Analytics", "Data Engineering", "Tableau", "API"]   ,
    category: "Analytics/ Statistics",
    github: "https://github.com/shreyasah99/Real-Time-Insurance-Claims-Data-ETL-Pipeline",
    webapp: "https://github.com/shreyasah99/Real-Time-Insurance-Claims-Data-ETL-Pipeline",
  },
  {
    id: 88,
    title: "FDA Drug Adverse Events: End-to-End ETL and Analytics Pipeline",
    date: "December 2024",
    description:
      "An end-to-end ETL pipeline that ingests, processes, and visualizes FDA drug adverse event data using Python, Snowflake, Airflow, Docker, and Tableau for enhanced drug safety monitoring.",
    image:
      "https://raw.githubusercontent.com/shreyasah99/shreyasah99.github.io/gh-pages/Images/drug.png",
    tags:  ["ETL Pipeline", "Data Engineering",  "Apache Airflow", "Snowflake", "Docker", "Tableau", "Python"]   ,
    category: "Analytics/ Statistics",
    github: "https://github.com/shreyasah99/FDA-Drug-Adverse-Events-End-to-End-ETL-and-Analytics-Pipeline",
    webapp: "https://github.com/shreyasah99/FDA-Drug-Adverse-Events-End-to-End-ETL-and-Analytics-Pipeline",
  },

];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
